import classNames from 'classnames';
import { FC, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../event.module.scss';

export const HumanizeDuration: FC<{ timestamp: number }> = ({ timestamp }) => {
  const { t } = useTranslation();
  const [duration, setDuration] = useState<string>('');

  useEffect(() => {
    format();
    const interval = setInterval(() => {
      format();
    }, 9000);
    return () => clearInterval(interval);
  }, []);

  const format = () => {
    const delta = Math.round((Date.now() - timestamp) / 1000);

    const minute = 60;
    const hour = minute * 60;
    const day = hour * 24;
    const month = day * 30;

    let durationString;

    if (delta < 15) {
      durationString = t('now');
    } else if (delta < minute) {
      durationString = `${delta} ${t('seconds ago')}`;
    } else if (delta < 2 * minute) {
      durationString = t('a minute ago');
    } else if (delta < hour) {
      durationString = `${Math.floor(delta / minute)} ${t('minutes ago')}`;
    } else if (Math.floor(delta / hour) === 1) {
      durationString = t('1 hour ago');
    } else if (delta < day) {
      durationString = `${Math.floor(delta / hour)} ${t('hours ago')}`;
    } else if (delta < day * 2) {
      durationString = t('one day ago');
    } else if (delta < month) {
      durationString = `${Math.floor(delta / day)} ${t('days ago')}`;
    }
    setDuration(durationString);
  };

  return (
    <div
      className={classNames(
        styles.triggered,
        duration === 'now' ? [styles['triggered--new']] : [styles['triggered--old']]
      )}
    >
      {duration}
    </div>
  );
};
